module.exports = __webpack_public_path__ + "img/trial2-4.91aad009.png";